import { HTMLProps } from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { trioUITheme } from '@/styles/theme';
import * as Styles from './WarningMessage.styles';

export type WarningType = 'error' | 'warning';

type WarningMessageProps = Pick<HTMLProps<HTMLDivElement>, 'style'> & {
  errorMessage?: string;
  type?: WarningType;
};

const WarningMessage = ({
  errorMessage,
  type = 'error',
  ...props
}: WarningMessageProps): JSX.Element | null => {
  if (!errorMessage) {
    return null;
  }

  return (
    <Styles.FeedbackArea className="error-message" {...props}>
      <ErrorIcon
        sx={{
          width: '12px',
          height: '12px',
          color: type === 'error' ? trioUITheme.colors.warning : '#FF991C',
          marginRight: '4px',
        }}
      />
      <Styles.FeedbackMessage $type={type}>{errorMessage}</Styles.FeedbackMessage>
    </Styles.FeedbackArea>
  );
};

export default WarningMessage;
